export const DEFAULT_DIALECT = '2';
